import * as customerService from '../../../services/customerService'
import validateCreateAccountResult from './ValidateCreateAccountResult';

const validateCreateAccountCheck = async (lastName, ssn, dateOfBirth) => {
    let response = await customerService.check(lastName, ssn, dateOfBirth);
    return new validateCreateAccountResult(response);
};


export default validateCreateAccountCheck;